import React from 'react'
import { PageLoader } from 'components/loader'
import * as S from './DefaultLogin.styles'
import useUserPlatform from 'utils/hooks/use-platform'
import ButtonHelpToAccess from 'components/help-to-access'
import type { LoginAreaProps } from './DefaultLogin.types'
import LoginArea from './login-area'
import { useTranslation } from 'i18n'

const DefaultLogin: React.FC<LoginAreaProps> = props => {
  const { isMobile } = useUserPlatform()
  const { t } = useTranslation()

  if (!props.localInfosChecked) {
    return <PageLoader />
  }

  return (
    <S.ContainerMobile as="main" data-testid="default-login">
      <h1 className="sr-only">{t('Entrar')}</h1>
      <S.ContainerDesktop>
        <S.LeavesContainer>
          <S.LeavesImg />
        </S.LeavesContainer>
        {props.loginRequiresPassword && isMobile && (
          <S.ButtonNotMe onClick={props.handleNotMe}>
            {t('Não sou eu')}
          </S.ButtonNotMe>
        )}
        <S.ArvoreImg />
        <S.WelcomeText>
          {props?.userName
            ? `Oi, ${props?.userName?.split(' ')[0]} 👋`
            : 'Boas-vindas'}
        </S.WelcomeText>
        {!isMobile && <LoginArea {...props} />}
      </S.ContainerDesktop>
      {isMobile && <LoginArea {...props} />}
      <ButtonHelpToAccess />
    </S.ContainerMobile>
  )
}

export default DefaultLogin
